import { BFColors } from "../../../constants/Colors"
import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetView,
} from "@gorhom/bottom-sheet"
import * as React from "react"
import { useCallback, useEffect, useRef } from "react"
import { Horizontal, Vertical } from "../../../components/standard/BFLayout"
import { Body, H2, H5 } from "../../../components/standard/BFText"
import {
  BFPressable,
  PrimaryButton,
} from "../../../components/buttons/CommonButtons"
import Svg, { G, Path } from "react-native-svg"
import { View } from "react-native"
import XIcon from "phosphor-react-native/src/icons/X"

function PopupClipart() {
  return (
    <Svg width={143} height={96} viewBox="0 0 143 96" fill="none">
      <G>
        <Path
          d="M25.083 37.79l-3.45 4.649-20.433.817 3.45-4.65 20.434-.817h-.001z"
          fill="#286588"
        />
        <Path
          d="M1.155 43.34a.096.096 0 01-.04-.13l.007-.012 3.45-4.65a.097.097 0 01.074-.038l20.433-.817a.097.097 0 01.081.153l-3.45 4.65a.097.097 0 01-.073.038l-20.433.817a.096.096 0 01-.049-.01zM4.7 38.7l-3.302 4.45 20.185-.806 3.303-4.45L4.7 38.7z"
          fill="#121F3A"
        />
        <Path
          d="M4.65 38.606l-3.45 4.65-1.104-5.833 3.45-4.65 1.104 5.833z"
          fill="#286588"
        />
        <Path
          d="M1.155 43.34a.097.097 0 01-.05-.067L.002 37.44a.096.096 0 01.017-.075l3.45-4.65a.097.097 0 01.135-.019.1.1 0 01.037.059l1.104 5.832a.096.096 0 01-.017.075l-3.45 4.65a.097.097 0 01-.122.028zM.2 37.448l1.055 5.574 3.294-4.438-1.055-5.575-3.294 4.439z"
          fill="#121F3A"
        />
        <Path
          d="M6.576 48.783l-3.45 4.65L2.021 47.6l3.45-4.65 1.103 5.832z"
          fill="#286588"
        />
        <Path
          d="M3.081 53.518a.097.097 0 01-.05-.068l-1.104-5.833a.096.096 0 01.017-.075l3.45-4.65a.097.097 0 01.136-.018.1.1 0 01.037.058l1.104 5.833a.096.096 0 01-.017.075l-3.45 4.65a.097.097 0 01-.123.027zm-.956-5.894L3.18 53.2l3.293-4.439-1.055-5.574-3.293 4.438z"
          fill="#121F3A"
        />
        <Path
          d="M27.009 47.966l-3.45 4.65-20.434.817 3.45-4.65 20.434-.817z"
          fill="#286588"
        />
        <Path
          d="M3.081 53.518a.096.096 0 01-.04-.13l.008-.013 3.45-4.65a.097.097 0 01.073-.038l20.433-.817a.097.097 0 01.082.153l-3.45 4.65a.097.097 0 01-.074.038l-20.433.817a.096.096 0 01-.049-.01zm3.545-4.64l-3.303 4.45 20.186-.806 3.302-4.451-20.185.807z"
          fill="#121F3A"
        />
        <Path
          d="M3.546 32.774l20.433-.817 1.104 5.832-20.433.817-1.104-5.832z"
          fill="#fff"
        />
        <Path
          d="M4.605 38.691a.097.097 0 01-.05-.068l-1.104-5.832a.096.096 0 01.078-.112l.013-.002 20.433-.817a.097.097 0 01.1.079l1.103 5.832a.096.096 0 01-.091.114l-20.433.817a.096.096 0 01-.049-.01zm-.943-5.826l1.067 5.642 20.238-.81-1.067-5.64-20.238.808z"
          fill="#121F3A"
        />
        <Path
          d="M6.576 48.783l-1.104-5.832 20.433-.817 1.104 5.832-20.433.817z"
          fill="#fff"
        />
        <Path
          d="M6.53 48.869a.097.097 0 01-.05-.068l-1.103-5.833a.096.096 0 01.077-.112c.005 0 .01 0 .014-.002l20.433-.816a.097.097 0 01.099.078l1.104 5.832a.096.096 0 01-.078.113l-.014.001-20.432.817a.097.097 0 01-.05-.01zm-.943-5.827l1.068 5.641 20.238-.809-1.068-5.64-20.238.808z"
          fill="#121F3A"
        />
        <Path
          d="M141.555 69.729v6.164l-5.876 5.842V75.57l5.876-5.841z"
          fill="#286588"
        />
        <Path
          d="M135.679 81.832a.098.098 0 01-.099-.097V75.57a.1.1 0 01.029-.069l5.875-5.84a.1.1 0 01.14 0c.019.017.03.043.03.069v6.164c0 .026-.011.05-.029.069l-5.876 5.841a.096.096 0 01-.07.029zm.099-6.22v5.886l5.678-5.645v-5.887l-5.678 5.645z"
          fill="#121F3A"
        />
        <Path
          d="M124.816 76.474v6.164l-7.222-4.754V71.72l7.222 4.754z"
          fill="#286588"
        />
        <Path
          d="M124.816 82.736a.098.098 0 01-.055-.017l-7.222-4.754a.096.096 0 01-.044-.08V71.72c0-.054.044-.098.099-.098a.1.1 0 01.055.016l7.222 4.754a.098.098 0 01.044.082v6.164a.098.098 0 01-.099.098zm-7.123-4.904l7.024 4.624v-5.93l-7.024-4.623v5.93z"
          fill="#121F3A"
        />
        <Path
          d="M138.032 85.211v6.164l-7.222-4.752V80.46l7.222 4.752z"
          fill="#286588"
        />
        <Path
          d="M138.032 91.472a.1.1 0 01-.055-.016l-7.221-4.752a.097.097 0 01-.045-.081v-6.165c0-.054.045-.097.099-.097.02 0 .039.005.055.016l7.222 4.752a.096.096 0 01.044.081v6.165a.098.098 0 01-.099.097zm-7.123-4.901l7.024 4.622v-5.93l-7.024-4.622v5.93z"
          fill="#121F3A"
        />
        <Path
          d="M142.901 80.324v6.165l-4.869 4.886V85.21l4.869-4.886z"
          fill="#286588"
        />
        <Path
          d="M138.032 91.472a.098.098 0 01-.099-.097V85.21c0-.025.01-.05.028-.068l4.869-4.886a.1.1 0 01.141 0 .1.1 0 01.029.069v6.164c0 .026-.01.05-.028.069l-4.869 4.886a.1.1 0 01-.071.029zm.099-6.22v5.885l4.671-4.688v-5.886l-4.671 4.688z"
          fill="#121F3A"
        />
        <Path
          d="M124.935 86.3v6.164l-5.995-3.984v-6.164l5.995 3.984z"
          fill="#286588"
        />
        <Path
          d="M124.935 92.562a.103.103 0 01-.055-.017l-5.995-3.984a.099.099 0 01-.044-.082v-6.164c0-.054.045-.097.099-.097.02 0 .039.005.056.016l5.995 3.984a.097.097 0 01.043.081v6.165a.098.098 0 01-.099.098zm-5.896-4.135l5.797 3.853v-5.928l-5.797-3.853v5.928z"
          fill="#121F3A"
        />
        <Path
          d="M130.81 80.459v6.164l-5.875 5.841V86.3l5.875-5.841z"
          fill="#286588"
        />
        <Path
          d="M124.935 92.562a.098.098 0 01-.099-.098V86.3c0-.026.01-.05.029-.07l5.875-5.84a.1.1 0 01.169.069v6.164c0 .026-.01.05-.028.069l-5.876 5.841a.096.096 0 01-.07.03v-.001zm.099-6.222v5.887l5.677-5.645v-5.887l-5.677 5.645z"
          fill="#121F3A"
        />
        <Path
          d="M135.56 65.745l5.995 3.984-5.876 5.841 7.222 4.754-4.869 4.886-7.222-4.752-5.875 5.842-5.995-3.985 5.876-5.841-7.222-4.754 4.869-4.888 7.222 4.754 5.875-5.841z"
          fill="#75FAD4"
        />
        <Path
          d="M124.935 86.398a.103.103 0 01-.055-.017l-5.995-3.984a.096.096 0 01-.014-.15l5.79-5.757-7.122-4.688a.097.097 0 01-.015-.15l4.869-4.887a.1.1 0 01.125-.013l7.154 4.71 5.818-5.785a.1.1 0 01.125-.013l5.995 3.985c.045.03.057.09.026.136l-.011.014-5.79 5.757 7.121 4.688a.097.097 0 01.016.15l-4.869 4.886a.1.1 0 01-.125.013l-7.154-4.708-5.818 5.785a.1.1 0 01-.07.028h-.001zm-5.84-4.097l5.827 3.873 5.818-5.784a.1.1 0 01.125-.012l7.153 4.708 4.728-4.745-7.122-4.688a.097.097 0 01-.028-.136l.012-.014 5.791-5.758-5.827-3.873-5.817 5.784a.1.1 0 01-.125.012l-7.154-4.709-4.727 4.746 7.122 4.689c.045.03.058.09.028.135l-.013.015-5.791 5.757z"
          fill="#121F3A"
        />
        <Path
          d="M31.075 8.543c-1.245.066-2.345-.278-3.304-1.03-.96-.752-1.55-1.746-1.776-2.984-.224-1.237-.002-2.267.672-3.09l.033-.04-3.924 4.667c-.011.013-.023.026-.033.04-.673.824-.896 1.853-.672 3.09.225 1.238.816 2.232 1.776 2.985.958.752 2.06 1.095 3.304 1.03 1.192-.063 2.13-.5 2.811-1.31l3.924-4.667c-.681.81-1.619 1.247-2.811 1.31v-.001z"
          fill="#fff"
        />
        <Path
          d="M28.853 12.893c-.496.242-1.063.381-1.697.415-1.262.066-2.396-.287-3.37-1.05-.974-.764-1.583-1.79-1.812-3.045-.229-1.261.004-2.328.692-3.17l.034-.04 3.924-4.668a.096.096 0 01.053-.032.096.096 0 01.098.038.09.09 0 01.019.045.097.097 0 01-.021.075h-.001l-.032.04c-.65.795-.87 1.808-.651 3.01.22 1.208.805 2.192 1.74 2.925.934.734 2.024 1.073 3.238 1.01 1.159-.062 2.082-.49 2.742-1.276a.098.098 0 01.152.124l-.002.002-3.925 4.667a3.61 3.61 0 01-1.184.93h.003zM26.037 2.339l-3.218 3.829c-.651.796-.87 1.809-.652 3.01.22 1.208.805 2.192 1.74 2.926.935.733 2.024 1.073 3.238 1.009 1.16-.061 2.082-.49 2.742-1.275l3.16-3.758c-.557.334-1.215.522-1.967.562-1.263.066-2.396-.287-3.37-1.05-.974-.764-1.583-1.789-1.811-3.045-.15-.82-.103-1.56.137-2.207z"
          fill="#121F3A"
        />
        <Path
          d="M43.541 16.45l-3.924 4.667-21.895 1.152 3.924-4.667L43.54 16.45z"
          fill="#fff"
        />
        <Path
          d="M39.66 21.205a.1.1 0 01-.037.01l-21.896 1.152a.098.098 0 01-.08-.161l3.924-4.667a.096.096 0 01.07-.035l21.895-1.151a.098.098 0 01.08.16l-3.924 4.667a.097.097 0 01-.032.025zm-21.718.955l21.627-1.138 3.752-4.462-21.627 1.138-3.752 4.462z"
          fill="#121F3A"
        />
        <Path
          d="M21.646 17.602l-3.924 4.667-1.173-6.45 3.925-4.666 1.172 6.45z"
          fill="#fff"
        />
        <Path
          d="M17.765 22.357a.098.098 0 01-.139-.07l-1.173-6.45a.097.097 0 01.022-.08l3.924-4.667a.098.098 0 01.171.046l1.173 6.45a.097.097 0 01-.021.08l-3.925 4.667a.099.099 0 01-.031.025zm-1.11-6.51l1.126 6.2 3.76-4.473-1.126-6.199-3.76 4.473z"
          fill="#121F3A"
        />
        <Path
          d="M34.52 27.496c-1.245.065-2.347-.285-3.308-1.053-.962-.767-1.554-1.768-1.78-3.005-.14-.774-.105-1.462.106-2.068.127-.363.317-.697.57-1l-3.924 4.667c-.676.809-.9 1.83-.676 3.068.225 1.237.817 2.238 1.78 3.005.961.769 2.063 1.118 3.308 1.053 1.176-.063 2.103-.494 2.779-1.298l3.924-4.667c-.676.804-1.603 1.235-2.779 1.298z"
          fill="#fff"
        />
        <Path
          d="M32.275 31.85c-.49.24-1.05.377-1.673.41-1.264.066-2.4-.295-3.375-1.074-.975-.777-1.586-1.808-1.814-3.064-.23-1.262.005-2.321.696-3.149l3.924-4.668a.098.098 0 01.15.126 3.1 3.1 0 00-.552.97c-.204.586-.238 1.266-.101 2.02.22 1.207.806 2.198 1.744 2.945.936.748 2.027 1.095 3.242 1.031 1.143-.06 2.054-.484 2.708-1.261l.001-.002a.098.098 0 01.152.124l-.002.003-3.924 4.667c-.331.394-.724.702-1.176.922zm-2.812-10.56l-3.204 3.81c-.652.78-.873 1.786-.654 2.988.22 1.208.806 2.198 1.744 2.945.936.748 2.027 1.096 3.242 1.032 1.144-.06 2.055-.485 2.71-1.263l3.161-3.76c-.55.328-1.197.512-1.936.551-1.264.067-2.4-.294-3.374-1.074-.976-.776-1.587-1.807-1.815-3.064-.143-.787-.106-1.5.11-2.118l.016-.047z"
          fill="#121F3A"
        />
        <Path
          d="M31.075 8.543c-1.245.066-2.345-.278-3.304-1.03-.96-.752-1.55-1.746-1.776-2.984-.225-1.237-.002-2.267.671-3.09.672-.823 1.63-1.268 2.875-1.333a4.843 4.843 0 013.276 1.01c.97.737 1.569 1.723 1.794 2.96.225 1.238-.006 2.275-.69 3.115-.684.838-1.633 1.29-2.847 1.353v-.001z"
          fill="#75FAD4"
        />
        <Path
          d="M32.776 8.226a4.343 4.343 0 01-1.696.415c-1.262.066-2.396-.287-3.37-1.05-.974-.764-1.583-1.79-1.811-3.045-.23-1.261.003-2.328.692-3.17.687-.841 1.678-1.302 2.945-1.369a4.96 4.96 0 013.34 1.03c.987.75 1.603 1.766 1.831 3.02.23 1.261-.01 2.335-.71 3.195-.34.418-.749.743-1.22.974zm-1.707.22c1.18-.063 2.114-.506 2.777-1.318.662-.812.887-1.834.669-3.035-.22-1.206-.81-2.181-1.756-2.9a4.766 4.766 0 00-3.213-.99c-1.21.065-2.153.501-2.804 1.298-.65.796-.87 1.809-.65 3.01.219 1.208.804 2.193 1.74 2.926.934.733 2.023 1.073 3.237 1.009z"
          fill="#121F3A"
        />
        <Path
          d="M20.474 11.153L42.369 10l1.173 6.45-21.896 1.151-1.172-6.45z"
          fill="#75FAD4"
        />
        <Path
          d="M43.657 16.542l-22.092 1.162-1.208-6.643L42.45 9.899l1.208 6.643zm-21.93.958l21.698-1.141-1.137-6.255-21.698 1.14 1.137 6.256z"
          fill="#121F3A"
        />
        <Path
          d="M36.263 20.067c.971.738 1.566 1.71 1.786 2.918.224 1.236-.004 2.282-.685 3.135-.681.854-1.63 1.312-2.843 1.376-1.246.065-2.348-.285-3.309-1.053-.962-.767-1.554-1.768-1.78-3.005-.225-1.238 0-2.26.676-3.068.674-.81 1.634-1.246 2.878-1.311a4.845 4.845 0 013.277 1.009z"
          fill="#75FAD4"
        />
        <Path
          d="M36.198 27.184c-.49.24-1.048.377-1.672.41-1.265.066-2.4-.295-3.375-1.075-.976-.776-1.586-1.807-1.814-3.064-.23-1.262.005-2.32.696-3.148.689-.827 1.68-1.28 2.948-1.346a4.958 4.958 0 013.34 1.028c.987.75 1.6 1.752 1.823 2.979.23 1.26-.008 2.34-.704 3.213-.346.432-.76.767-1.242 1.003zm-4.912-7.617a3.32 3.32 0 00-1.103.865c-.652.781-.873 1.787-.654 2.989.22 1.208.806 2.198 1.744 2.945.936.748 2.027 1.096 3.242 1.032 1.18-.062 2.113-.513 2.772-1.34.66-.826.884-1.854.666-3.056a4.494 4.494 0 00-1.748-2.857 4.766 4.766 0 00-3.213-.99c-.645.035-1.215.172-1.706.412z"
          fill="#121F3A"
        />
        <Path
          d="M134.972 56.296l-4.057 4.491-23.21.467 4.057-4.491 23.21-.467z"
          fill="#286588"
        />
        <Path
          d="M130.957 60.874a.088.088 0 01-.04.01l-23.21.467a.097.097 0 01-.074-.162l4.056-4.491a.1.1 0 01.07-.032l23.21-.467a.097.097 0 01.074.161l-4.056 4.492a.103.103 0 01-.03.022zm-23.031.28l22.944-.463 3.879-4.294-22.944.462-3.879 4.294z"
          fill="#121F3A"
        />
        <Path
          d="M111.761 56.763l-4.056 4.491-1.096-7.517 4.056-4.492 1.096 7.518z"
          fill="#286588"
        />
        <Path
          d="M107.748 61.341a.098.098 0 01-.14-.072l-1.095-7.518a.097.097 0 01.023-.079l4.057-4.491a.097.097 0 01.137-.007.099.099 0 01.03.058l1.096 7.517a.094.094 0 01-.024.079l-4.056 4.491a.103.103 0 01-.03.022h.002zm-1.037-7.573l1.06 7.269 3.888-4.304-1.06-7.27-3.888 4.306z"
          fill="#121F3A"
        />
        <Path
          d="M133.875 48.778l1.096 7.518-23.21.467-1.096-7.518 23.21-.467z"
          fill="#fff"
        />
        <Path
          d="M135.014 56.383a.092.092 0 01-.041.01l-23.21.466a.096.096 0 01-.097-.083l-1.096-7.517a.096.096 0 01.082-.11h.012l23.21-.468a.096.096 0 01.097.083l1.096 7.518a.095.095 0 01-.053.1v.001zm-23.169.282l23.015-.463-1.068-7.325-23.015.463 1.068 7.325z"
          fill="#121F3A"
        />
        <Path
          d="M24.021 90.83c-.938 2.486 1.32 5.247 4.072 5.003l72.922-6.71c1.016-.084 1.813-.555 2.318-1.237l10.103-8.338a3.236 3.236 0 01-2.319 1.237l-72.922 6.71c-2.752.244-5.008-2.534-4.072-5.003l24.873-65.688c.1-.283.256-.56.444-.797l-8.934 7.628a2.852 2.852 0 00-.444.798L24.022 90.83z"
          fill="#fff"
        />
        <Path
          d="M26.786 95.906a4.153 4.153 0 01-2.34-1.543c-.812-1.066-1.03-2.403-.587-3.567L49.9 24.4c.12-.299.276-.576.466-.832l8.934-7.629c.043-.069.155-.094.223-.033.069.043.094.155.033.222a2.81 2.81 0 00-.423.764L34.261 82.579c-.415 1.056-.203 2.265.543 3.251.812 1.066 2.058 1.626 3.35 1.514l72.923-6.71a3.249 3.249 0 001.875-.823l.329-.37c.062-.067.154-.076.221-.016.068.062.095.156.034.223-.105.136-.228.27-.349.387l-9.753 7.951c-.55.751-1.419 1.215-2.417 1.3l-72.92 6.692c-.426.05-.862.008-1.292-.09l-.02.017v.001zm-2.609-4.987c-.414 1.056-.202 2.265.544 3.251.812 1.066 2.057 1.626 3.35 1.514l72.92-6.692c.906-.077 1.679-.494 2.203-1.175l8.973-7.095a4.238 4.238 0 01-1.049.246l-72.922 6.71c-1.404.119-2.773-.49-3.648-1.653-.812-1.066-1.03-2.403-.587-3.567l24.65-65.088-7.987 6.368a2.81 2.81 0 00-.422.764l-26.04 66.396.016.02z"
          fill="#121F3A"
        />
        <Path
          d="M38.195 87.495c-2.754.262-5.01-2.516-4.073-4.985l24.872-65.688c.468-1.234 1.562-1.932 2.762-2.034a3.96 3.96 0 013.409 1.483l48.049 58.978c1.818 2.206.636 5.308-2.098 5.554l-72.92 6.691z"
          fill="#E14A3E"
        />
        <Path
          d="M36.908 87.552a4.153 4.153 0 01-2.34-1.543c-.812-1.066-1.03-2.403-.587-3.567l24.873-65.688c.467-1.216 1.553-2.024 2.902-2.149 1.331-.126 2.667.442 3.55 1.534l48.049 58.978c.916 1.13 1.162 2.544.637 3.79-.496 1.14-1.56 1.914-2.853 2.026l-72.922 6.71a3.997 3.997 0 01-1.31-.091zm28.159-71.218A3.8 3.8 0 0062.98 15a3.725 3.725 0 00-1.183-.079c-1.22.12-2.206.846-2.625 1.938L34.301 82.547c-.415 1.056-.203 2.265.544 3.251.811 1.066 2.057 1.626 3.35 1.514l72.92-6.692c1.182-.104 2.147-.796 2.578-1.833.476-1.124.255-2.425-.596-3.458l-48.05-58.978.02-.017z"
          fill="#121F3A"
        />
        <Path
          d="M69.412 34.488l4.63 28.361-6.504.593-5.961-28.236 7.835-.718z"
          fill="#fff"
        />
        <Path
          d="M67.486 63.6c-.055-.004-.104-.064-.117-.12l-5.961-28.235c-.033-.04-.01-.092.012-.127.022-.034.08-.065.116-.061l7.836-.719c.074-.011.16.052.17.127l4.63 28.361c.01.092-.035.18-.127.189l-6.505.592-.054-.005v-.001zm-5.722-28.248l5.883 27.917 6.19-.568-4.57-28.045-7.503.696z"
          fill="#121F3A"
        />
        <Path
          d="M75.346 69.574l1.204 6.424-6.504.592-1.187-6.421 6.505-.592-.018-.002z"
          fill="#fff"
        />
        <Path
          d="M70.012 76.751c-.055-.005-.122-.067-.117-.12l-1.204-6.424c-.033-.04-.01-.092.012-.127.022-.034.08-.065.116-.061l6.504-.593c.075-.01.16.052.171.127l1.205 6.423c.032.04.009.092-.013.127-.021.034-.08.065-.116.061l-6.504.593-.054-.005v-.001zm-.965-6.437l1.143 6.107 6.19-.568-1.143-6.106-6.19.567z"
          fill="#121F3A"
        />
      </G>
    </Svg>
  )
}

export const NegativeROISheet = ({
  visible,
  onClose,
}: {
  visible: boolean
  onClose: (moveOn: boolean) => void
}) => {
  const bottomSheetModalRef = useRef<BottomSheetModal>(null)

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        appearsOnIndex={0}
        disappearsOnIndex={-1}
        onPress={() => {
          onClose(false)
        }}
      />
    ),
    []
  )

  useEffect(() => {
    if (!visible) {
      bottomSheetModalRef.current?.dismiss()
      onClose(false)
    } else {
      bottomSheetModalRef.current?.present()
    }
  }, [visible])

  return (
    <BottomSheetModal
      ref={bottomSheetModalRef}
      backdropComponent={renderBackdrop}
      backgroundStyle={{ backgroundColor: "#FFFFFF" }}
      handleIndicatorStyle={{ backgroundColor: BFColors.offWhite }}
      enableDynamicSizing={true}
    >
      <BottomSheetView>
        <Horizontal className="items-start justify-end py-3.5 px-8">
          <BFPressable
            testID="close-negative-roi-x"
            onPress={() => {
              onClose(false)
            }}
            title="Loan Dashboard Loan List Modal Close"
          >
            {(pressed) => (
              <XIcon
                style={{
                  opacity: pressed ? 0.5 : 1,
                }}
              />
            )}
          </BFPressable>
        </Horizontal>
        <Vertical className="items-center w-full">
          <Vertical className="w-full max-w-sm">
            <Vertical className="items-center justify-center gap-5 my-10">
              <View className="mb-10">
                <PopupClipart />
              </View>
              <H2 className="text-center" color="primary">
                Oops–{"\n"}Your profit is negative
              </H2>
              <Body className="text-center pb-10" color="primary">
                It looks like your numbers might need an adjustment. Want to change
                anything?
              </Body>
              <PrimaryButton
                title="Review & Adjust"
                testID="review-adjust"
                onPress={() => {
                  onClose(false)
                }}
              />
              <H5
                className="underline text-center"
                color="primaryLight"
                onPress={() => {
                  onClose(true)
                }}
              >
                Continue with Negative Profit
              </H5>
            </Vertical>
          </Vertical>
        </Vertical>
      </BottomSheetView>
    </BottomSheetModal>
  )
}
